export const HEATMAP_COLORS = [
  'rgba(249, 193, 146, 1)',
  'rgba(249, 176, 115, 1)',
  'rgba(245, 162, 92, 1)',
  'rgba(248, 144, 85, 1)',
  'rgba(245, 117, 51, 1)',
  'rgba(243, 97, 30, 1)'
]

export const ZOOM_MIN = 24
export const ZOOM_MIN_DEFAULT = 20
export const ZOOM_MAX = 6

export default {
  HEATMAP_COLORS
}



// WEBPACK FOOTER //
// ./src/constants/maps.js